module.exports = __webpack_public_path__ + "5a3173dc0b5808faaf679199a7edaefb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/calendar/icon-apple-t1.svg
// module id = 399
// module chunks = 0